export default __webpack_public_path__ + "static/media/russian poker-11.2ada0ec6.png";